// src/components/common/IconSearchSupplierButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndustry } from '@/icons';
import './IconSearchSupplierButton.css';

interface IconSearchSupplierButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  className?: string;
}

const IconSearchSupplierButton: React.FC<IconSearchSupplierButtonProps> = ({
  onClick,
  title,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      className={`icon-search-supplier-button ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={faIndustry} />
    </button>
  );
};

export default IconSearchSupplierButton;
